import { Component, OnDestroy, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { versionInfo } from '../../../appVersion/versionInfo';
import { VersionService } from '../../common/service/version.service';
import { select, Store } from '@ngrx/store';
import { InGeApiState, InventeringsNiva } from '../../store/state-model/inge-api.model';
import { Subscription } from 'rxjs';
import { WindowRef } from '../../common/service/window-ref.service';
@Component({
    selector: 'app-site-header',
    templateUrl: './site-header.component.html',
    styleUrls: ['./site-header.component.scss']
})
export class SiteHeaderComponent implements OnInit, OnDestroy {
    appVersion: string;
    skogsstyrelsenUrl: string;

    private subs: Subscription[] = [];

    constructor(private versionService: VersionService, private titleService: Title, private store: Store<InGeApiState>, private windowRef: WindowRef) {}

    ngOnInit(): void {
        this.skogsstyrelsenUrl = environment.skogsstyrelsenUrl;

        this.subs.push(
            this.versionService.getVersionInfo().subscribe({
                next: (res) => {
                    this.appVersion = res.BuildNumber;
                },
                error: (err) => {
                    this.appVersion = versionInfo.BuildNumber;
                    console.info('Kunde inte hämta app version, visar default version');
                }
            })
        );

        this.titleService.setTitle('Äbin Rapport');

        this.subs.push(
            this.store
                .pipe(
                    select((x) => {
                        if (x && x.abin?.inventeringar && x.abin.inventeringar.length > 0) {
                            const senaste = x.abin.inventeringar[0];
                            const niva = x.abin.inventeringsNiva;
                            switch (niva) {
                                case InventeringsNiva.LAND:
                                    return 'Område: Hela landet';
                                case InventeringsNiva.LANDSDEL:
                                    return `Område: ${senaste.landsdelNamn}`;
                                case InventeringsNiva.LAN:
                                    return `Område: ${senaste.lanNamn}`;
                                case InventeringsNiva.AFO:
                                    return `Område: ${senaste.afoNamn}, ${senaste.lanNamn} `;
                                case InventeringsNiva.STRATUM:
                                    return `Område: Delområde ${senaste.delomrNamn} i ${senaste.afoNamn}, ${senaste.lanNamn}`;

                                default:
                                    return '';
                            }
                        }
                    })
                )
                .subscribe((res) => {
                    let title = 'Äbin Rapport';
                    if (res && res.length > 0) {
                        title += ' - ' + res;

                        // Matomo
                        let _paq = ((this.windowRef.nativeWindow as any)._paq = (this.windowRef.nativeWindow as any)._paq || []);
                        _paq.push(['setDocumentTitle', title]);
                        _paq.push(['setCustomUrl', window.location.href]);
                        /* tracker methods like "setCustomDimension" should be called before "trackPageView" */
                        _paq.push(['trackPageView']);
                        _paq.push(['enableLinkTracking']);
                    }
                    this.titleService.setTitle(title);
                })
        );
    }

    ngOnDestroy(): void {
        this.subs?.forEach((x) => x.unsubscribe());
    }
}
